var _defs, _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginHero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      transform: "scaleX(-1)"
    },
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 670 666",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-2{fill:#955646}.cls-3{fill:#0d2135}.cls-4{fill:#cd694a}.cls-7{fill:#61382d}.cls-11{fill:#e7592f}.cls-13{fill:#fff}.cls-16{fill:#57697b}.cls-18{fill:#394450}.cls-22{fill:#6fa9dc}.cls-24{fill:#3c4545}.cls-25{fill:#5b6a6b}.cls-32{fill:#20211b}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 335,
    cy: 325,
    r: 325,
    fill: "#ffeae5",
    id: "Layer_2",
    "data-name": "Layer 2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M594.49 492.57l-4.54-4.7-10.23 8.87c2.79 2.66 3.07 4.49 3.07 4.49l4.63 5.45 10-7.51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M594.49 492.57l9.42 5.32a4.18 4.18 0 012.08 3 4.06 4.06 0 01-.17 1.86 4.14 4.14 0 01-1 1.59l-20.35 20.52a14.46 14.46 0 01-6.74 3.94 3.13 3.13 0 01-2.13-.21 3 3 0 01-1.48-1.53 2.92 2.92 0 01-.24-1.54 3 3 0 01.58-1.46c7.16-9.68 8.31-22.86 8.31-22.86 14.69 1.11 11.72-8.63 11.72-8.63z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M534.36 421.47l55.64 66.4-25.34 23.41-51.75-68.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M528.16 513.48l.19-7.45h-13.53c0 3.81-1.18 5.25-1.18 5.25l-.78 7 12.47 1.79z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M528.16 513.48l2.66 10.31a4.17 4.17 0 010 1.86 4 4 0 01-.8 1.69 4.13 4.13 0 01-1.47 1.18 4.4 4.4 0 01-1.86.42h-29.21a14.71 14.71 0 01-7.59-2 3 3 0 01-1.34-1.65 3 3 0 01.1-2.1 3.08 3.08 0 011-1.23 3.25 3.25 0 011.47-.61c12.09-1.7 22.56-10.08 22.56-10.08 9.43 11.07 14.48 2.21 14.48 2.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M556.59 389.05L517 397.17a23.16 23.16 0 00-12.7 7.29 22.25 22.25 0 00-5.61 13.31l-6 88.23h35.71l3.27-83.46h56.26c16.28 0 22.23-14.5 22.23-14.5l-7.48-19-34.68-2.22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M578.29 311.4l3.41-14.19a8 8 0 00.11-3.23 8.16 8.16 0 00-1.17-3 8.29 8.29 0 00-2.27-2.34 8.49 8.49 0 00-3-1.31l-1.3-.28a6.52 6.52 0 01-2.95-1.49 6.25 6.25 0 01-1.81-2.72c-.39-1.17-.79-2.4-1-3.28-.78-3.72-3.6-2.45-4.2-4.57s1.23-5.25-.12-10.47l41.6 3c-4.09 12.68-7.82 18.07 2.69 30.27z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.77 301.08l-3 10.32 10.82-9.4z",
    fill: "#2a67b2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.13 297.4c-11.18-3.07-23.63 5.21-27.81 15s-10.81 14.12-10 25.16-10.7 51.54-10.7 51.54c21.21-1.9 34.25 17.5 53.51 19 13.62-25.67 15.18-69 11.48-85.21s-5.3-22.42-16.48-25.49z",
    fill: "#1f344a"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M549.87 355.86a37.17 37.17 0 00-4.47-2.22 1 1 0 00-.51-.11 1.12 1.12 0 00-.5.15 1 1 0 00-.36.37 1 1 0 00-.12.49 1 1 0 00.08.45 1 1 0 00.28.36l5.44 4.65zm-3.65-8.86l-7.44 2.75a1.42 1.42 0 00-.57.39 1.52 1.52 0 00-.33.61 1.61 1.61 0 000 .69 1.4 1.4 0 00.33.61 1.49 1.49 0 001.45.44l8.24-2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M564.51 357.45l-4.51-1.16a10.39 10.39 0 01-5.56-3.61l-4.73-6a4.42 4.42 0 00-3.41-1.66l-14.3-.14a1.57 1.57 0 00-.68.15 1.52 1.52 0 00-.54.43 1.4 1.4 0 00-.29.63 1.43 1.43 0 000 .68 1.5 1.5 0 00.43.7 1.56 1.56 0 00.75.37l13.3 2.41 3 7.2a8.33 8.33 0 002.15 3 8.56 8.56 0 003.27 1.81l4.82 1.41 4.25 2.75zM82.5 304.51a20.1 20.1 0 003.28 11.09l.22.4a20.17 20.17 0 0036.83-11.47v-.86a13.55 13.55 0 01-.11-1.43c-.08-.64-.17-1.26-.3-1.88a20.31 20.31 0 00-4.17-8.74l-.16-.17a19.81 19.81 0 00-6.88-5.31 20.17 20.17 0 00-28.71 18.37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M90.36 322.59c3.61 6 4 10-3.34 19.07l27.15.17s-5-13 1.67-15.36 7-2.58 6.86-9.13c-.26-3.68 2-3.64 2-5.78 0-1.92-1.43-3.67-1.91-7.91a11.33 11.33 0 01-.11-1.43l-24.55 8.89-12.35 4.49.22.4c1.69 2.52 3.2 4.66 4.36 6.59z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M102.67 312.72a4.85 4.85 0 10-4.83-4.85 4.84 4.84 0 004.83 4.85z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.85 380.55c2.65-18.45-6.69-36.21-9.78-42.35l-20.46-6.11c-3.27 6.54-20 28.57-21 48.46z",
    fill: "#6fcdde"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.85 380.55c9.7-18.78 30.11-10.58 33.19 0z",
    fill: "#122133"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M107.5 380.55l6-9.24 20.5 9.07z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.63 339.55h-57v5.38h57z",
    fill: "#424435"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M330.81 344.92h-60.54v5.46h60.54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M344.63 350.39h-66.8v4.81h66.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.48 355.2H287.6v5h62.88z",
    fill: "#1b4481"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M341.72 360.2h-61a2.89 2.89 0 00-2.92 2.85 2.89 2.89 0 002.92 2.85h61a2.88 2.88 0 002.91-2.85 2.88 2.88 0 00-2.91-2.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M611.57 430.05l20.65-116.79a5.17 5.17 0 012.14-3.32 5.38 5.38 0 013.92-.86 5.24 5.24 0 013.39 2.09 5 5 0 01.88 3.83 2.56 2.56 0 010 .27l-26.97 115.56a2 2 0 01-.89 1.22 2.09 2.09 0 01-2.78-.54 2 2 0 01-.34-1.46z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.94 438.31h-99.22a3.72 3.72 0 01-1.9-.52 3.61 3.61 0 01-1.36-1.41 3.56 3.56 0 01.19-3.72 23.45 23.45 0 018-7.17 24.2 24.2 0 0110.46-2.92h68.37a24.2 24.2 0 0110.52 2.92 23.45 23.45 0 018 7.17 3.55 3.55 0 01.62 1.83 3.47 3.47 0 01-.43 1.89 3.63 3.63 0 01-1.35 1.4 3.83 3.83 0 01-1.9.53z",
    fill: "#f4d58d"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M613.58 438.31l5.51 44.69-2.87 4.79-11.91-49.44zm-73.33 0l-11.89 90.63H532l17.54-90.63zm12.53-71.99H180.51a7 7 0 100 14h372.27a7 7 0 100-14zM194.94 528.94h-6.13l25.05-148.62h10.75z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M538.35 528.94h6.13l-25.05-148.62h-10.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.63 105.46V2.94",
    strokeMiterlimit: 10,
    stroke: "#57697b",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M379.63 162.28a8.52 8.52 0 10-8.72-8.52 8.62 8.62 0 008.72 8.52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M379.63 109.65a4.19 4.19 0 10-4.29-4.19 4.24 4.24 0 004.29 4.19z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M418.78 153.76h-78.24a37.58 37.58 0 015.9-20.2 38.86 38.86 0 0115.92-14.1 16 16 0 005.14-4 15.56 15.56 0 003.05-5.71l1.24-4.27h15.72l1.25 4.26a15.58 15.58 0 003 5.72 16 16 0 005.14 4 38.71 38.71 0 0115.94 14.1 37.5 37.5 0 015.9 20.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.15 466L21.52 299.67h30a25.6 25.6 0 0115.78 5.63 24.54 24.54 0 018.66 14.09l9 40.69a25.51 25.51 0 009 14.61 26.5 26.5 0 0016.38 5.85H172a24.37 24.37 0 0124.06 27.57l-4.8 36.68a23.77 23.77 0 01-7.94 15 24.82 24.82 0 01-16.07 6.21z",
    fill: "#30629e"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M154.74 466l20 61.24h5L167.15 466zm-76.33 0l-14.72 37.77-4-6.07L66 466z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M529.09 362.27h-50.57a2 2 0 00-2.06 2 2 2 0 002.06 2h50.57a2 2 0 002.07-2 2 2 0 00-2.07-2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M462.3 313.35l12 48a2.07 2.07 0 002.49 1.48 2 2 0 001.52-2.44l-12-48a2.07 2.07 0 00-2.5-1.48 2 2 0 00-1.51 2.44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M199.82 366.31h40.7a2 2 0 002.06-2 2 2 0 00-2.06-2h-40.7a2 2 0 00-2.07 2 2 2 0 002.07 2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M244.29 361.37l9.85-48a2 2 0 00-.15-1.45 2.09 2.09 0 00-1.09-1 1.55 1.55 0 00-.71 0 1.71 1.71 0 00-1.12.81 1.59 1.59 0 00-.21.67l-9.85 48a2 2 0 00.15 1.45 2.11 2.11 0 001.1 1 1.73 1.73 0 001.35-.3 1.66 1.66 0 00.47-.52 1.64 1.64 0 00.21-.66z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.13 338.82c0 1.28 0 2.54.06 3.76a4.77 4.77 0 00-4.56-.53 5.14 5.14 0 00-2.07 2 4.94 4.94 0 00-.68 2.73 9.23 9.23 0 001.73 4.92 37.34 37.34 0 003.83 4.69c.48.52.95 1 1.42 1.57a12.74 12.74 0 012.82 5.68c.38 1.73.65 2.67.65 2.67h13.72a113.14 113.14 0 003.22-27.48zM420 357c-.47-.54-1-1.07-1.44-1.6a34.49 34.49 0 01-3.69-4.5 7.91 7.91 0 01-1.49-4.12 3.58 3.58 0 01.45-1.92 3.72 3.72 0 011.41-1.4 2.63 2.63 0 011.27-.22 3.21 3.21 0 012 1 3 3 0 01.82 2c.27 4.4.74 8.28 1.23 11.42z",
    fill: "#725f87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.74 331.08c1.88-2.44 3.79-5 4.62-7.89s.36-6.44-2-8.46c-1.1-.94-2.49-1.48-3.63-2.36s-2-2.37-1.51-3.7c.34-.91 1.28-1.59 1.35-2.55.08-1.12-1-1.94-1.65-2.84-1.32-1.81-1.09-4.32-.2-6.36a54.72 54.72 0 013.51-5.69 13.39 13.39 0 002-8.9 8.21 8.21 0 00-1.92-4.17 8.57 8.57 0 00-3.88-2.55c-3.07-.79-6.75 1-7.5 4a4.16 4.16 0 000 2.13 4.28 4.28 0 001 1.87 3.28 3.28 0 001.91.94 3.34 3.34 0 002.1-.42 2.61 2.61 0 001.1-1.75 2.49 2.49 0 00-.08-1.05 2.38 2.38 0 00-.49-.93",
    stroke: "#a9a9aa",
    strokeWidth: 0.25,
    strokeMiterlimit: 10,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.41 148.78h-62v74.88h62z",
    strokeWidth: 4,
    stroke: "#725f87",
    strokeMiterlimit: 10,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M153.29 160.28h-38.61v51.88h38.61z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.29 199.6h-38.61v12.57h38.61z",
    fill: "#f3ba64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M153.28 199.6v-11.92l-38.61 8v3.93z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M131 168.18v31.41h-6.64v-15.22a7.83 7.83 0 00-2.36-5.57 8.18 8.18 0 00-5.7-2.3h-1.67v-8.32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254 148.78h-62v74.88h62z",
    stroke: "#e7592f",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.26 160.28h-38.61v51.88h38.61z",
    fill: "#f58b6e"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M223.42 181.4a29.44 29.44 0 00-8.56-8.26 30.17 30.17 0 00-11.21-4.27v13.89z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M242.26 172.14c-15.44-9-18.41 3.06-24.55 6.1s-14.12.51-14.12.51v33.41h38.62z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.26 197.28h-13.14v14.88h13.14z",
    fill: "#b3c8ca"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M232.34 207.11h-3.22v5h3.22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M242.26 193.64h-13.14v3.64h13.14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.12 212.16c-7.66 0-11.55-19-25.47-18.52v18.52z",
    fill: "#1e1f1f"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M548.56 79.94H530v118.53s104.14-.61 104.08-.68a143.72 143.72 0 00-9.52-20.71c-13.7-23.29-38.42-60.26-45.27-67.11a329.89 329.89 0 00-30.73-30.03z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.89 111.44c-1.6-.22-3.26.76-4.89 1.88-6.57 4.53-12.68 5.72-17.31 4.53a32.09 32.09 0 01-7.5-2.86v66.51h76.31s-10.19-19.79-21.5-37.11c-11.57-17.64-24.28-32.83-25.11-32.95z",
    fill: "#de9885"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.76 181.27c-14.73-7.79-33.15-38.82-51.36-38.82h-24.21v39.05s76.53.28 75.57-.23z",
    fill: "#74899f"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M550.19 158.8h21a5.88 5.88 0 014.1 1.66 5.6 5.6 0 011.7 4 5.6 5.6 0 01-1.7 4 5.88 5.88 0 01-4.1 1.66h-21V158.8zm0 11.35h21a5.88 5.88 0 014.1 1.66 5.6 5.6 0 011.7 4 5.6 5.6 0 01-1.7 4 5.88 5.88 0 01-4.1 1.66h-21v-11.32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M105.69 302.8c1.5 2.87 4.25.76 3.25-1.07a5.78 5.78 0 01-.84-2.44 5.72 5.72 0 01.32-2.56c.21-.46.54-.87.71-1.36a24.44 24.44 0 00.27-2.7c.41-1.86 2.55-2.77 4.45-3a6.61 6.61 0 003-.66 3.75 3.75 0 001.47-2.86 4.47 4.47 0 00-.83-3.18c-1.12-1.39-3.07-1.67-4.88-1.84-1.31-.12-2-1.82-3.22-2.37s-2.74.18-4.15.19c-2.55 0-4.49-2.36-6.95-3a5.49 5.49 0 00-3.84.42c-1.9 1-3.16 3.09-5.23 3.67-1 .29-2.15.15-3.21.35a5.23 5.23 0 00-2.39 1.21 5.11 5.11 0 00-1.45 2.21c-.66 2.13.11 4.62-1 6.55-.87 1.49-2.63 2.21-3.78 3.49a5.55 5.55 0 00-1.23 2.53 5.44 5.44 0 00.21 2.8c.47 1.35 1.48 2.48 1.88 3.86.7 2.42-.38 5.25.6 7.57.75 1.81 2.68 2.89 3.53 4.65.47.95.6 2.06 1.09 3a3.74 3.74 0 001.11 1.3 4.05 4.05 0 001.57.7 3.35 3.35 0 001.69-.16 3.17 3.17 0 001.38-1c.74-.92.94-2.26 1.91-2.94.8-.56 1.86-.48 2.81-.72a4.1 4.1 0 002.31-1.54 3.91 3.91 0 00.76-2.62l-.35-5.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M307.2 468v-8.62c-3.8 2.68-8.69 6.83-10.1 12.83s-8.18 18.83-18 19.33c0 0-10.84.67-17.51 1a49.66 49.66 0 00-15.34 3.67c-1.85.83-8.39.17-7.91-7.33s11.46-8 11.31-.34c.46-5.5-3.26-8.16-7.76-8.5s-10.23 3.94-7.75 15.34-6.67 11.66-5.49 27.83l79.78-.25c.45-3.32-.08-7.62-.35-13a76.49 76.49 0 011.22-19.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M220.25 501.5v22.55a5.79 5.79 0 001.2 3.75 6.05 6.05 0 003.34 2.19 5 5 0 001 .11h103a5 5 0 001-.1 6.09 6.09 0 003.34-2.19 5.9 5.9 0 001.2-3.75V501.5a6.4 6.4 0 00-6.14-6.63h-7.6a23.46 23.46 0 00-12.87 3.87 55 55 0 01-60.85 0 23.46 23.46 0 00-12.87-3.87h-7.61a6.39 6.39 0 00-6.14 6.63z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.25 521.1v2.95a5.79 5.79 0 001.2 3.75 6.05 6.05 0 003.34 2.19h105a6.09 6.09 0 003.34-2.19 5.9 5.9 0 001.2-3.75v-2.95z",
    fill: "#97acaf"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M307.2 468l2 22.64a7.28 7.28 0 011.41 3.82 4.66 4.66 0 00.76-2.31 20.71 20.71 0 01.21 8 3.7 3.7 0 001.33-1.5 15.55 15.55 0 01.28 2.54 5.61 5.61 0 01-.59 2.51 4 4 0 001.33-1.1 3.83 3.83 0 00.72-1.54 9.4 9.4 0 001.18 4.23 5.38 5.38 0 01.81-3 7.52 7.52 0 00.89 5 12 12 0 012.27-4.74 3.51 3.51 0 00.41 1.59 3.57 3.57 0 001.1 1.25 6.59 6.59 0 01.89-4.37 4 4 0 001.2 2.46 12.57 12.57 0 01.83-4.74 95.49 95.49 0 004.19-10.1l.38-1a3.44 3.44 0 00-.63-3.39l-5.88-6.76c.49-.47 1-1 1.45-1.44a6.41 6.41 0 00-2 .83 7.15 7.15 0 012.42-3.2 6.06 6.06 0 00-3.61 1.82 4.46 4.46 0 01.84-1.9 4.71 4.71 0 011.61-1.33 9.18 9.18 0 00-3.32.91 5.27 5.27 0 012.73-2.23 5.67 5.67 0 00-2.21-.06 23.23 23.23 0 00-3.31.51 13 13 0 00-4.52-2.68 13.25 13.25 0 00-5.23-.72z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M586 284.23a21 21 0 10-21.43-21 21.2 21.2 0 0021.43 21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M581.84 265.62c-.55 2.41-3.86 2.72-4.22.57a16.5 16.5 0 011-9.05 4.5 4.5 0 00-2.19.48 4.41 4.41 0 00-1.66 1.46c-1.47 2-1 5.21-3 6.81a3.2 3.2 0 01-1.86.7 3.26 3.26 0 01-1.92-.52 2.76 2.76 0 01-.84-3.55 9.29 9.29 0 01-3.31 4.25 4.58 4.58 0 01-2.43.78 4.49 4.49 0 01-2.45-.66 4.33 4.33 0 01-1.26-1.4 5.54 5.54 0 01-.92-3.25c0-.93.38-1.82.51-2.74a6.4 6.4 0 00-.52-3.45 16.72 16.72 0 01-1.15-3.27 5.2 5.2 0 01.19-3 5.07 5.07 0 012.52-2.52 10.22 10.22 0 013.56-.87c-1-2.93.85-7.07 3.83-8.12a23.74 23.74 0 003.69-1.11 12.33 12.33 0 001.26-.88 9.31 9.31 0 014.75-1.69c2.13-.15 4.24.43 6.38.48 1.56 0 3.13-.21 4.69-.09a5.46 5.46 0 012.26.52 5.27 5.27 0 011.83 1.4 12.77 12.77 0 015.43-3.24 7.5 7.5 0 013.13-.19 7.38 7.38 0 012.94 1.09c1.38.95 2.31 2.42 3.66 3.41a6.76 6.76 0 003.49 1.29c1.81.14 3.59-.45 5.4-.67s3.89 0 5 1.44a10.62 10.62 0 011.3 3.29 6.15 6.15 0 002.52 3.25 26.2 26.2 0 002.82 1.24 8.06 8.06 0 013.57 3.5 7.82 7.82 0 01.76 4.89 2.86 2.86 0 01-.53 1.41 2.91 2.91 0 01-1.18 1 3.16 3.16 0 01-1.61-.21 3 3 0 01-1.27-1 6.85 6.85 0 00-2.47-2.06 11.83 11.83 0 00-3.2-.11c-2-.13-3.81-1.61-5.31-3-.38-.36-.94-.78-1.33-1.12a2.44 2.44 0 00-.92-.66 2.55 2.55 0 00-1.13-.17 1.56 1.56 0 00-.83.73 1.5 1.5 0 00-.14 1.08 4.07 4.07 0 001.16 1.91 25.76 25.76 0 008.07 5.77 13.22 13.22 0 012.54 1.36c1.57 1.24 2.2 3.25 2.84 5.13s1.46 3.87 3.21 4.86a14.42 14.42 0 015 4.89c1.16 1.9 1.42 4.49 0 6.24-.93 1.17-2.43 1.8-3.35 3a17.33 17.33 0 00-1.16 2 5.23 5.23 0 01-2 2 3.17 3.17 0 01-1.41.39 3.08 3.08 0 01-1.43-.29 4 4 0 01-1.82-3.19 19.91 19.91 0 00-.45-3.77c-1-3.13-4.93-4.8-5.68-8-.33-1.4 0-2.89-.32-4.3a6.29 6.29 0 00-1.31-2.37 6.41 6.41 0 00-2.19-1.63 20.4 20.4 0 01-2-1 2.75 2.75 0 01-.84-.75 2.83 2.83 0 01-.49-1 7.21 7.21 0 00-1 3.41 7.06 7.06 0 00.8 3.45c1.22 2.08 3.48 3.52 4.32 5.77s0 5.14.8 7.56c1.15 3.3 5.3 5.24 5.63 8.71a4.33 4.33 0 01-.28 1.95 4.42 4.42 0 01-1.11 1.65 4 4 0 01-4.09.87c-.93-.37-1.68-1.14-2.66-1.3a9.62 9.62 0 00-1.86.06 4.17 4.17 0 01-2.08-.52 3.93 3.93 0 01-1.52-1.48c-1-1.79-.5-4.08-1.2-6-1-2.74-4.28-4.29-5.12-7.09-.57-2 .27-4.19-.26-6.2s-2-2.89-3.58-4.06-3.47-2.12-4.09-4.57z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M586.85 271.66a5 5 0 10-5.13-5 5.06 5.06 0 005.13 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486 530H235.62L80 526.9c19.18 19.84 35.4 37.83 53.1 52.31 66.23 54.15 127.14 72 201.32 72a327.05 327.05 0 00184.23-56.72c44.09-30.23 68.17-63.86 71.72-67.88z",
    fill: "#fdb29d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginHero);
export default __webpack_public_path__ + "static/media/login-hero.f345bb66c0343807b84b3d024582a0ff.svg";
export { ForwardRef as ReactComponent };